<div class="align-items-center flex-column module-box-wrapper h-100">
  <div class="login-wrapper w-100">
    <div class="login-form">
      <div class="align-items-center d-flex flex-column flex-fill gap-3 h-100 position-relative py-5 w-100">
        <div class="align-items-center d-flex flex-column flex-fill h-100 justify-content-center">
          <div class="text-center mb-5">
            <img src="assets/images/logo.png" class="img-fluid splash-logo" alt="" />
          </div>
          <h1 class="page-notfound-title text-white">
            @if (pageType() === '404') {
              404
            } @else if (pageType() === 'construction') {
              <i class="bi bi-cone-striped"></i>
            }
          </h1>
          <h3 class="notfound-subtitle mb-5 text-white text-center">
            @if (pageType() === '404') {
              Looks like you are Lost
            } @else if (pageType() === 'construction') {
              Page under construction
            }
          </h3>
          <button class="btn btn-primary" routerLink="/">Go Back Home</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-module-loader></app-module-loader>
